import { render, staticRenderFns } from "./CustomerNotificationDialog.vue?vue&type=template&id=30d1154f"
import script from "./CustomerNotificationDialog.vue?vue&type=script&lang=js"
export * from "./CustomerNotificationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports